/**
 * ArbiHunter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: ROOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class VacancyBodyDTO {
    /**
    * Название вакансии
    */
    'name': string;
    /**
    * Vacancy in archived mode
    */
    'isArchived'?: boolean;
    /**
    * Описание вакансии
    */
    'description': string;
    /**
    * Идентификаторы категорий
    */
    'categoriesIds': Array<number>;
    /**
    * Идентификаторы вертикалей
    */
    'verticalsIds': Array<number>;
    /**
    * Идентификаторы навыков
    */
    'skillsIds': Array<number>;
    /**
    * Идентификаторы источников
    */
    'sourcesIds': Array<number>;
    /**
    * Идентификаторы географических регионов
    */
    'geosIds': Array<number>;
    /**
    * Зарплата
    */
    'salary': number;
    /**
    * Телефон
    */
    'phone': string;
    /**
    * Почта
    */
    'email': string;
    'hash': string;
    /**
    * Отображать ли почту
    */
    'showEmail': boolean;
    /**
    * Отображать ли тедефон
    */
    'showPhone': boolean;
    /**
    * Минимальная зарплата
    */
    'salaryMin': number;
    /**
    * Максимальная зарплата
    */
    'salaryMax': number;
    /**
    * Комиссия
    */
    'commission': number;
    /**
    * Тип компенсации
    */
    'compensation': VacancyBodyDTOCompensationEnum;
    /**
    * Валюта
    */
    'currency': VacancyBodyDTOCurrencyEnum;
    /**
    * Требуемый опыт работы
    */
    'experience': VacancyBodyDTOExperienceEnum;
    /**
    * График работы
    */
    'schedule': VacancyBodyDTOScheduleEnum;
    /**
    * Тип занятости
    */
    'employment': VacancyBodyDTOEmploymentEnum;
    /**
    * Знание языков
    */
    'languageKnowledges': Array<any>;
    /**
    * Отображать контактное имя
    */
    'showContactName': boolean;
    /**
    * Контактное имя
    */
    'contactName': string;
    /**
    * Отображать Telegram никнейм
    */
    'showTelegramNickname': boolean;
    /**
    * Telegram никнейм
    */
    'telegramNickname': string;
    /**
    * Название компании
    */
    'company': string;
    /**
    * Идентификатор страны
    */
    'countryId': number;
    /**
    * Идентификатор города
    */
    'cityId': number;
    /**
    * Идентификатор изображения
    */
    'imageId': number;
    /**
    * Дата архивации
    */
    'archivedAt': Date;
    /**
    * Удалённая работа
    */
    'isRemote': boolean;
    /**
    * Завершенные шаги
    */
    'completedSteps': Array<number>;
    'isTop': boolean;
    'topPurchasedAt': Date;
    'topAt': Date;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "isArchived",
            "baseName": "isArchived",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "categoriesIds",
            "baseName": "categoriesIds",
            "type": "Array<number>",
            "format": ""
        },
        {
            "name": "verticalsIds",
            "baseName": "verticalsIds",
            "type": "Array<number>",
            "format": ""
        },
        {
            "name": "skillsIds",
            "baseName": "skillsIds",
            "type": "Array<number>",
            "format": ""
        },
        {
            "name": "sourcesIds",
            "baseName": "sourcesIds",
            "type": "Array<number>",
            "format": ""
        },
        {
            "name": "geosIds",
            "baseName": "geosIds",
            "type": "Array<number>",
            "format": ""
        },
        {
            "name": "salary",
            "baseName": "salary",
            "type": "number",
            "format": ""
        },
        {
            "name": "phone",
            "baseName": "phone",
            "type": "string",
            "format": ""
        },
        {
            "name": "email",
            "baseName": "email",
            "type": "string",
            "format": ""
        },
        {
            "name": "hash",
            "baseName": "hash",
            "type": "string",
            "format": ""
        },
        {
            "name": "showEmail",
            "baseName": "showEmail",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "showPhone",
            "baseName": "showPhone",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "salaryMin",
            "baseName": "salaryMin",
            "type": "number",
            "format": ""
        },
        {
            "name": "salaryMax",
            "baseName": "salaryMax",
            "type": "number",
            "format": ""
        },
        {
            "name": "commission",
            "baseName": "commission",
            "type": "number",
            "format": ""
        },
        {
            "name": "compensation",
            "baseName": "compensation",
            "type": "VacancyBodyDTOCompensationEnum",
            "format": ""
        },
        {
            "name": "currency",
            "baseName": "currency",
            "type": "VacancyBodyDTOCurrencyEnum",
            "format": ""
        },
        {
            "name": "experience",
            "baseName": "experience",
            "type": "VacancyBodyDTOExperienceEnum",
            "format": ""
        },
        {
            "name": "schedule",
            "baseName": "schedule",
            "type": "VacancyBodyDTOScheduleEnum",
            "format": ""
        },
        {
            "name": "employment",
            "baseName": "employment",
            "type": "VacancyBodyDTOEmploymentEnum",
            "format": ""
        },
        {
            "name": "languageKnowledges",
            "baseName": "languageKnowledges",
            "type": "Array<any>",
            "format": ""
        },
        {
            "name": "showContactName",
            "baseName": "showContactName",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "contactName",
            "baseName": "contactName",
            "type": "string",
            "format": ""
        },
        {
            "name": "showTelegramNickname",
            "baseName": "showTelegramNickname",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "telegramNickname",
            "baseName": "telegramNickname",
            "type": "string",
            "format": ""
        },
        {
            "name": "company",
            "baseName": "company",
            "type": "string",
            "format": ""
        },
        {
            "name": "countryId",
            "baseName": "countryId",
            "type": "number",
            "format": ""
        },
        {
            "name": "cityId",
            "baseName": "cityId",
            "type": "number",
            "format": ""
        },
        {
            "name": "imageId",
            "baseName": "imageId",
            "type": "number",
            "format": ""
        },
        {
            "name": "archivedAt",
            "baseName": "archivedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "isRemote",
            "baseName": "isRemote",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "completedSteps",
            "baseName": "completedSteps",
            "type": "Array<number>",
            "format": ""
        },
        {
            "name": "isTop",
            "baseName": "isTop",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "topPurchasedAt",
            "baseName": "topPurchasedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "topAt",
            "baseName": "topAt",
            "type": "Date",
            "format": "date-time"
        }    ];

    static getAttributeTypeMap() {
        return VacancyBodyDTO.attributeTypeMap;
    }

    public constructor() {
    }
}

export enum VacancyBodyDTOCompensationEnum {
    SALARY = 'salary',
    COMMISSION = 'commission',
    GYBRID = 'gybrid',
    PIECEWORK = 'piecework',
    CONTRACT = 'contract'
}
export enum VacancyBodyDTOCurrencyEnum {
    EUR = 'EUR',
    AED = 'AED',
    AFN = 'AFN',
    XCD = 'XCD',
    XCD2 = 'XCD',
    ALL = 'ALL',
    AMD = 'AMD',
    AOA = 'AOA',
    ARS = 'ARS',
    USD = 'USD',
    EUR2 = 'EUR',
    AUD = 'AUD',
    AWG = 'AWG',
    EUR3 = 'EUR',
    AZN = 'AZN',
    BAM = 'BAM',
    BBD = 'BBD',
    BDT = 'BDT',
    EUR4 = 'EUR',
    XOF = 'XOF',
    BGN = 'BGN',
    BHD = 'BHD',
    BIF = 'BIF',
    XOF2 = 'XOF',
    EUR5 = 'EUR',
    BMD = 'BMD',
    BND = 'BND',
    BOB = 'BOB',
    USD2 = 'USD',
    BRL = 'BRL',
    BSD = 'BSD',
    BTN = 'BTN',
    NOK = 'NOK',
    BWP = 'BWP',
    BYN = 'BYN',
    BZD = 'BZD',
    CAD = 'CAD',
    AUD2 = 'AUD',
    CDF = 'CDF',
    XAF = 'XAF',
    CDF2 = 'CDF',
    CHE = 'CHE',
    XOF3 = 'XOF',
    NZD = 'NZD',
    CLF = 'CLF',
    XAF2 = 'XAF',
    CNY = 'CNY',
    COP = 'COP',
    CRC = 'CRC',
    CUC = 'CUC',
    CVE = 'CVE',
    ANG = 'ANG',
    AUD3 = 'AUD',
    EUR6 = 'EUR',
    CZK = 'CZK',
    EUR7 = 'EUR',
    DJF = 'DJF',
    DKK = 'DKK',
    DOP = 'DOP',
    DOP2 = 'DOP',
    DZD = 'DZD',
    USD3 = 'USD',
    EUR8 = 'EUR',
    EGP = 'EGP',
    MAD = 'MAD',
    ERN = 'ERN',
    EUR9 = 'EUR',
    ETB = 'ETB',
    EUR10 = 'EUR',
    FJD = 'FJD',
    USD4 = 'USD',
    DKK2 = 'DKK',
    EUR11 = 'EUR',
    XAF3 = 'XAF',
    GBP = 'GBP',
    XCD3 = 'XCD',
    GEL = 'GEL',
    EUR12 = 'EUR',
    GBP2 = 'GBP',
    GHS = 'GHS',
    GIP = 'GIP',
    DKK3 = 'DKK',
    GMD = 'GMD',
    GNF = 'GNF',
    EUR13 = 'EUR',
    XAF4 = 'XAF',
    EUR14 = 'EUR',
    GTQ = 'GTQ',
    USD5 = 'USD',
    XOF4 = 'XOF',
    GYD = 'GYD',
    HKD = 'HKD',
    HNL = 'HNL',
    HRK = 'HRK',
    HTG = 'HTG',
    HUF = 'HUF',
    IDR = 'IDR',
    EUR15 = 'EUR',
    ILS = 'ILS',
    GBP3 = 'GBP',
    INR = 'INR',
    USD6 = 'USD',
    IQD = 'IQD',
    IRR = 'IRR',
    ISK = 'ISK',
    EUR16 = 'EUR',
    GBP4 = 'GBP',
    JMD = 'JMD',
    JOD = 'JOD',
    JPY = 'JPY',
    KES = 'KES',
    KGS = 'KGS',
    KHR = 'KHR',
    AUD4 = 'AUD',
    KMF = 'KMF',
    XCD4 = 'XCD',
    KPW = 'KPW',
    KPW2 = 'KPW',
    KWD = 'KWD',
    KYD = 'KYD',
    KZT = 'KZT',
    LBP = 'LBP',
    XCD5 = 'XCD',
    CHF = 'CHF',
    LKR = 'LKR',
    LRD = 'LRD',
    LSL = 'LSL',
    EUR17 = 'EUR',
    EUR18 = 'EUR',
    EUR19 = 'EUR',
    LYD = 'LYD',
    MAD2 = 'MAD',
    EUR20 = 'EUR',
    MDL = 'MDL',
    EUR21 = 'EUR',
    EUR22 = 'EUR',
    MGA = 'MGA',
    USD7 = 'USD',
    XOF5 = 'XOF',
    MMK = 'MMK',
    MNT = 'MNT',
    MOP = 'MOP',
    USD8 = 'USD',
    EUR23 = 'EUR',
    MRU = 'MRU',
    XCD6 = 'XCD',
    EUR24 = 'EUR',
    MUR = 'MUR',
    MVR = 'MVR',
    MWK = 'MWK',
    MXN = 'MXN',
    MYR = 'MYR',
    MZN = 'MZN',
    NAD = 'NAD',
    XPF = 'XPF',
    NGN = 'NGN',
    AUD5 = 'AUD',
    NGN2 = 'NGN',
    NIO = 'NIO',
    EUR25 = 'EUR',
    NOK2 = 'NOK',
    NPR = 'NPR',
    AUD6 = 'AUD',
    NZD2 = 'NZD',
    NZD3 = 'NZD',
    OMR = 'OMR',
    PAB = 'PAB',
    PEN = 'PEN',
    XPF2 = 'XPF',
    PGK = 'PGK',
    PHP = 'PHP',
    PKR = 'PKR',
    PLN = 'PLN',
    EUR26 = 'EUR',
    NZD4 = 'NZD',
    USD9 = 'USD',
    EUR27 = 'EUR',
    USD10 = 'USD',
    PYG = 'PYG',
    QAR = 'QAR',
    EUR28 = 'EUR',
    RON = 'RON',
    RSD = 'RSD',
    RUB = 'RUB',
    RWF = 'RWF',
    SAR = 'SAR',
    SBD = 'SBD',
    SCR = 'SCR',
    SDG = 'SDG',
    SEK = 'SEK',
    SGD = 'SGD',
    SHP = 'SHP',
    EUR29 = 'EUR',
    NOK3 = 'NOK',
    EUR30 = 'EUR',
    SLL = 'SLL',
    EUR31 = 'EUR',
    XOF6 = 'XOF',
    SOS = 'SOS',
    SRD = 'SRD',
    SSP = 'SSP',
    STN = 'STN',
    SVC = 'SVC',
    ANG2 = 'ANG',
    SYP = 'SYP',
    SZL = 'SZL',
    USD11 = 'USD',
    XAF5 = 'XAF',
    EUR32 = 'EUR',
    XOF7 = 'XOF',
    THB = 'THB',
    TJS = 'TJS',
    NZD5 = 'NZD',
    USD12 = 'USD',
    TMT = 'TMT',
    TND = 'TND',
    TOP = 'TOP',
    TRY = 'TRY',
    TTD = 'TTD',
    AUD7 = 'AUD',
    TWD = 'TWD',
    TZS = 'TZS',
    UAH = 'UAH',
    UGX = 'UGX',
    USD13 = 'USD',
    USD14 = 'USD',
    UYI = 'UYI',
    UZS = 'UZS',
    EUR33 = 'EUR',
    XCD7 = 'XCD',
    VES = 'VES',
    USD15 = 'USD',
    USD16 = 'USD',
    VND = 'VND',
    VUV = 'VUV',
    XPF3 = 'XPF',
    USD17 = 'USD',
    YER = 'YER',
    EUR34 = 'EUR',
    ZAR = 'ZAR',
    ZMW = 'ZMW',
    ZWL = 'ZWL',
    AUD8 = 'AUD',
    FKP = 'FKP',
    GEL2 = 'GEL',
    LAK = 'LAK',
    MKD = 'MKD',
    USD18 = 'USD',
    ILS2 = 'ILS'
}
export enum VacancyBodyDTOExperienceEnum {
    NO_EXPERIENCE = 'noExperience',
    FROM1TO3 = 'from1to3',
    FROM3TO6 = 'from3to6',
    FROM6 = 'from6'
}
export enum VacancyBodyDTOScheduleEnum {
    FULL_DAY = 'fullDay',
    FLEXIBLE = 'flexible',
    REMOTE = 'remote'
}
export enum VacancyBodyDTOEmploymentEnum {
    FULL_TIME = 'fullTime',
    PART_TIME = 'partTime',
    PROJECT = 'project'
}

